export const API_START_LOADING = "apiStartLoading";
export const API_FINISH_LOADING = "apiFinishLoading";
export const APP_VERSION_GESEHEN = "appVersionGesehen";
export const UPDATE_VERFUEGBAR = "updateVerfuegbar";
